import {CookieConsentController, cookieConsentView} from '../../_shared/cookie-consent';

const cookieConsentCtrl = CookieConsentController(document.querySelector('#cookie-consent-overlay'));
cookieConsentView(cookieConsentCtrl);
